export default "__VITE_ASSET__mYAep1WA__"